import { Icon, IconSizeClasses, Select } from '@eppendorf/vnls-react-components';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
  notificationCadenceOptions,
  defaultNotificationCadence,
} from '$features/notifications/add-or-edit-notification-rule-dialog/constants';
import { NotificationRuleSubmitForm } from '$features/notifications/types';

import './notification-cadence.scss';

type NotificationCadenceProps = {
  formControl: UseFormReturn<NotificationRuleSubmitForm>;
};

export function NotificationCadence({ formControl }: NotificationCadenceProps) {
  const { t } = useTranslation();
  const { watch, setValue } = formControl;

  const notificationCadence = watch('notificationCadence', defaultNotificationCadence);

  const handleCadenceChange = (value: string) => {
    setValue('notificationCadence', Number(value), {
      shouldDirty: true,
      shouldValidate: true,
    });
  };

  return (
    <div className="notification-cadence flex flex__jc--center p-s border-s border-solid border-color-gray-300">
      <div className="notification-cadence__content flex flex-wrap flex__ai--center flex__jc--center">
        <div className="flex flex__ai--center flex__jc--center bg-blue-500 border-radius-xxl icon--s m-right-s">
          <Icon name="alarm-ringing" size={IconSizeClasses.XSmall} className="bg-white" />
        </div>
        <p className="p-right-m text-align-center">
          {t('escalationLayer.sendNotificationsEvery')}
        </p>
        <div className="notification-cadence__select p-right-s">
          <Select
            value={notificationCadence.toString()}
            onChange={handleCadenceChange}
            options={notificationCadenceOptions}
            ariaLabel="notification cadence"
          />
        </div>
      </div>
    </div>
  );
}
